import React, { FC } from 'react';
import { useScopedSelector } from 'ia-react-core';
import { StyledDiv } from './LoginInformation.styles';
import { Account } from '../../../interfaces/Account';
import Username from './Username';
import Password from './Password';
import SecurityQuestions from './SecurityQuestions';
import { AccountResourceInfo } from '../AccountResource';
import AuthenticationFactors from '../../AuthenticationFactors';

export interface LoginInformationProps { }

const LoginInformation: FC<LoginInformationProps> = () => {
  const account: Account = useScopedSelector(AccountResourceInfo.dataDst);

  if (!account) return null;

  return (
    <StyledDiv>
      <Username account={account} />
      <Password />
      <SecurityQuestions />
      <AuthenticationFactors />
    </StyledDiv>
  );
};

export default LoginInformation;
